import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext.jsx'
import { ToastContainer } from "react-toastify";
import { WishlistProvider } from "./context/WishlistContext.jsx";
import ratingLogger from '../src/component/RatingFlow/RatingFlowLogger.js'
import React from 'react';
import { HelmetProvider } from "react-helmet-async";
import { logClientError } from './utility/clientLogger.js'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("💥 App crashed:", error, info);

    logClientError("Error", error.toString(), info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <h2>Something went Wrong.</h2>
          <p>Please refresh the page.</p>
          {/* ✅ Only show error details in dev */}
          {/* {import.meta.env.DEV && ( */}
            <pre style={{ color: 'red', whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontSize: 12 }}>
              {this.state.error?.toString()}
            </pre>
          {/* )} */}
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}

if (typeof window !== 'undefined') {
  window.ratingLogger = ratingLogger;
}

// Global JavaScript errors
window.onerror = function (message, source, lineno, colno, error) {
  logClientError({
    level: "Error",
    message: String(message),
    details: error?.stack || `${source}:${lineno}:${colno}`
  });

  return false;
};

// Unhandled Promise errors
window.onunhandledrejection = function (event) {
  logClientError({
    level: "UnhandledPromise",
    message: event.reason?.message || String(event.reason),
    details: event.reason?.stack || JSON.stringify(event.reason)
  });
};

createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <BrowserRouter>
      <WishlistProvider>
        <AuthProvider>
          <HelmetProvider>
            <App />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              pauseOnHover
            />
          </HelmetProvider>
        </AuthProvider>
      </WishlistProvider>
    </BrowserRouter>
  </ErrorBoundary>
)
